module.exports = __webpack_public_path__ + "static/media/crash.57f07aef.svg";